export const OUR_CLIENTS = [
    {
        image: "https://newsoft-ns.com/media/home/our_clients_Brayan_Platte.webp",
        imageAlt: "Bryan Pratte - Co-Founder & CEO at Quarkworks",
        name: "Bryan Pratte",
        desc: "Co-founder & CEO at Quarkworks",
        country: "USA",
        clutch: "https://clutch.co/profile/newsoft#review-1724067",
        link: "https://clutch.co/profile/newsoft#review-1724067",
        text: [
            "“If I could hire more people from them for specific roles I have open, I would. We haven't had a bad candidate from them yet, and that's almost unheard of in the industry. Newsoft’s team are engineers first. They really understand how to build and grow engineering teams. That's really the reason why we decided to work with them.” ",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/home/our_clients_Benjamin_Davis.webp",
        imageAlt: "Benjamin Davis - Founder & CEO at TryNow",
        name: "Benjamin Davis",
        desc: "Founder & CEO at TryNow",
        country: "USA",
        clutch: "https://clutch.co/profile/newsoft#review-2137144",
        link: "https://clutch.co/profile/newsoft#review-2137144",
        text: [
            "“The Newsoft team’s contributions were monumental to our growth as an organization. We are so grateful for their support. Newsoft’s engineers were responsible for developing a resilient system for processing Shopify data updates and implementing a billing system. They worked around the clock to develop and test the product, with half of the day worked by the Ukranian team and the other half by our team in the US. The project resulted in valuable outcomes for both of us.”",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/home/our_clients_Jacob_Muchow.webp",
        imageAlt: "Jacob Muchow - Founder & CEO at Orbit",
        name: "Jacob Muchow",
        desc: "Founder at Orbit",
        country: "USA",
        clutch: "https://clutch.co/profile/newsoft#review-2141587",
        link: "https://clutch.co/profile/newsoft#review-2141587",
        text: [
            "“Newsoft delivered an MVP ahead of schedule, meeting expectations. The team was very flexible with the client's budget needs, goals, and timeline. They collaborated efficiently through weekly team meetings and email updates. Newsoft's team of strong developers was impressive.” ",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/home/our_clients_Brandon_Younessi.webp",
        imageAlt: "Brandon Younessi - Co-Founder at Bazo",
        name: "Brandon Younessi",
        desc: "Co-Founder at Bazo",
        country: "USA",
        clutch: "https://clutch.co/profile/newsoft#review-2237224",
        link: "https://clutch.co/profile/newsoft#review-2237224",
        text: [
            "“Thanks to their new app, the client has seen excellent results in user engagement, conversion rates, merchant satisfaction, security metrics, and inventory reduction. Newsoft has proven to be a reliable and talented partner, providing top-notch quality work as if they were part of the client’s team.” ",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/home/our_clients_Boris_Zlatkin.webp",
        imageAlt: "Boris Zlatkin - Co-Founder at Lootr",
        name: "Boris Zlatkin",
        desc: "Co-Founder at Lootr",
        country: "Israel",
        clutch: "https://clutch.co/profile/newsoft#review-1147620",
        link: "https://clutch.co/profile/newsoft#review-1147620",
        text: [
            "“I worked with Newsoft team for about 3 years on 3 different projects. Most important for me was communication, quality result, meeting deadlines and accurate estimations. And in all of the categories the team has exceeded expectations. Whenever they encounter bugs or complex technical challenges, they’re able to work through them. If you’re looking for a high quality engineering with a fair pricing, Newsoft team is your answer. I’ll gladly work with them again in the (hopefully near) future.” ",
        ],
    },
]
